import * as React from 'react';
import { DropdownPopover, Outside } from '@cian/ui-kit';
import { ISortingProps } from '../../types';

import { SortingDesktopDropdown } from '../SortingDesktopDropdown';
import { SortingButton } from '../SortingButton';

export const SortingDesktop: React.FC<ISortingProps> = ({ onChange, options, placeholder, selectedOption }) => {
  const [isOpenDropdown, setIsOpenDropdown] = React.useState(false);

  const dropdownRef = React.useRef<HTMLUListElement>(null);
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  const openDropdown = React.useCallback(() => {
    setIsOpenDropdown(true);
  }, []);

  const closeDropdown = React.useCallback(() => {
    setIsOpenDropdown(false);

    if (buttonRef.current) {
      buttonRef.current.focus();
    }
  }, []);

  return (
    <Outside onOutside={closeDropdown} active={isOpenDropdown} insideRefs={[dropdownRef]}>
      <div>
        <DropdownPopover
          open={isOpenDropdown}
          content={
            <SortingDesktopDropdown
              dropdownRef={dropdownRef}
              onChange={onChange}
              onClose={closeDropdown}
              selectedOption={selectedOption}
              options={options}
            />
          }
        >
          <SortingButton ref={buttonRef} onClick={isOpenDropdown ? closeDropdown : openDropdown}>
            {selectedOption ? String(selectedOption.label) : placeholder}
          </SortingButton>
        </DropdownPopover>
      </div>
    </Outside>
  );
};
